export default __webpack_public_path__ + "static/media/32.4cbc6808.jpg";